/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Options_Include_Comments_DescriptionInputs */

const en_export_power_point_options_include_comments_description = /** @type {(inputs: Export_Power_Point_Options_Include_Comments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adds all comment responses as slides to the export. This may increase file size significantly.`)
};

const de_export_power_point_options_include_comments_description = /** @type {(inputs: Export_Power_Point_Options_Include_Comments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügt alle Kommentarantworten als Folien zum Export hinzu. Dies kann die Dateigröße erheblich vergrößern.`)
};

/**
* | output |
* | --- |
* | "Adds all comment responses as slides to the export. This may increase file size significantly." |
*
* @param {Export_Power_Point_Options_Include_Comments_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_options_include_comments_description = /** @type {((inputs?: Export_Power_Point_Options_Include_Comments_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Options_Include_Comments_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_options_include_comments_description(inputs)
	return de_export_power_point_options_include_comments_description(inputs)
});